<script>
import { twoFactorAuthMethods } from '@state/helpers'
import { BIcon, BIconArrowUp, BIconEnvelope, BIconApp, BIconPhone } from 'bootstrap-vue'
export default {
  name: 'TwoFactorOptions',
  props: {
    a2fOptions: {
      type: Array,
      default: []
    },
    credentials: {
      type: Object,
      default: { username: '', password: ''}
    }
  },
  components: { 
    BIcon,
    BIconArrowUp, 
    BIconEnvelope,
    BIconApp,
    BIconPhone
  },
  data() {
    return {
      isEmailOptionVisible: false,
      isTotpOptionVisible: false,
      sendingEmail: false,
    }
  },
  computed: {
    getCompanyInfo: function () {
      return this.$store.state.appAuth.companyInfo || null;
    },
  },
  methods: {
    ...twoFactorAuthMethods,

    sendEmail() {
      this.sendingEmail = true;
      this.sendEmailAuth(this.credentials)
        .then((response) => { 
          console.log(response); 
          this.sendingEmail = false;
          this.continueAuth('email');
        })
        .catch((error) => { 
          console.log(error);
          this.sendingEmail = false;
          this.$axios_error_noty(error, this)
        })
    },
    continueAuth(option) {
      this.$emit('optionSelected', option);
    },
  },
  mounted() {
    this.isEmailOptionVisible = this.a2fOptions.filter(
      (value) => value.type == 'email').length ? true : false;
    this.isTotpOptionVisible = this.a2fOptions.filter(
      (value) => value.type == 'totp').length ? true : false;
  }
}
</script>

<template>
  <!-- Select verification type -->
  <div class="text-center m-auto p-3 otp">
    <div class="w-75 m-auto">
      <a href="/">
        <span
          ><b-img
            v-if="getCompanyInfo"
            :src="getCompanyInfo['dark_logo'] || require('@assets/images/logos/logo-dark.png')"
            alt="login"
            class="p-1"
            fluid
        /></span>
      </a>
    </div>
    <div class="text-dark my-2">
      {{$t('a2f_options.init_msg')}}
    </div>
    <div class="d-flex flex-column">
      <b-button
        variant="primary"
        block
        class="mt-2"
        @click="continueAuth('totp')"
        v-if="isTotpOptionVisible"
      >
        <!-- <b-spinner v-if="resendingToken" small class="align-middle"></b-spinner> -->
          <b-icon icon="phone" aria-hidden="true"></b-icon>
          <!-- {{ resendingToken ? 'Reenviando' : 'Reenviar' }} token de
          seguridad -->
          {{ $t('a2f_options.totp') }}
      </b-button>
      <b-button
        variant="primary"
        block
        class="mt-2"
        @click="sendEmail"
        v-if="isEmailOptionVisible"
      >
        <b-icon icon="envelope"></b-icon>
          <!-- {{ resendingToken ? 'Reenviando' : 'Reenviar' }} token de
          seguridad -->
          {{$t('a2f_options.email')}}
        <b-spinner v-if="sendingEmail" small class="align-baseline"></b-spinner>
      </b-button>
    </div>
  </div>
</template>

<style lang="scss" module></style>
